import React, { FC, memo, useMemo } from "react";
import { IPostCreateTempDetail } from "../../service/Index";
import styles from "../../styles/index";
import { isInCodoon } from "../../utils/bridge";
import "./ClubActivityRule.less";
import { HTML_URL_PAIRS } from "./urlTransform";

const PREFIX = "RuleModule";

interface IProps {
  detail: {
    title?: string;
    content?: string;
  };
}

const ClubActivityRule: FC<IProps> = memo((props) => {
  const { detail } = props;

  const htmlContent = useMemo((): string => {
    let content = detail.content || "";
    content = content.replace(/<p><\/p>/g, "");

    if (!isInCodoon()) {
      /**
       * 临时需求
       * 站外，希望把站内跳转到 微信小程序 的链接替换成 weixin:// 的链接
       * 迪卡侬
       */
      HTML_URL_PAIRS.forEach((urlPair) => {
        content = content.replaceAll(urlPair.inside, urlPair.outside);
      });
    }

    return content;
  }, [detail]);

  return (
    <div className={PREFIX}>
      {detail.title && (
        <div className={`${PREFIX}-title`}>·{detail.title}·</div>
      )}
      <div
        style={styles.rule}
        className="club-rule"
        dangerouslySetInnerHTML={{
          __html: htmlContent,
        }}
      />
    </div>
  );
});

export default ClubActivityRule;
